export default "__VITE_ASSET__CdFlCOZN__"